import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

const Home = () => {
  return (
    <div className="uxiang-home">
      {/* Header */}
      <header className="site-header">
        <Container>
          <Row className="align-items-center py-3">
            <Col xs={6} md={3}>
              <div className="logo">
                <h1 className="mb-0">友享</h1>
              </div>
            </Col>
            <Col xs={6} md={9}>
              <nav className="main-nav text-end">
                <a href="/" className="nav-link">首页</a>
                <a href="#policy" className="nav-link">协议及隐私政策</a>
                <a href="#contact" className="nav-link">联系我们</a>
              </nav>
            </Col>
          </Row>
        </Container>
      </header>

      {/* Hero Section */}
      <section className="hero-banner">
        <div className="hero-overlay">
          <Container>
            <div className="hero-content">
              <h1 className="hero-title">友享</h1>
              <p className="hero-subtitle">买越多省越多</p>
            </div>
          </Container>
        </div>
      </section>

      {/* Main Content */}
      <main className="main-content">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto">
              {/* Article 1 */}
              <article className="content-article">
                <h2 className="article-title">
                  <a href="https://www.uxiang123.com/2022/05/26/%e5%8f%8b%e4%ba%abapp-%e4%b9%b0%e7%9a%84%e8%b6%8a%e5%a4%9a%ef%bc%8c%e7%9c%81%e7%9a%84%e8%b6%8a%e5%a4%9a/" target="_blank" rel="noopener noreferrer">
                    友享APP介绍 - 买的越多，省的越多
                  </a>
                </h2>
                <div className="article-meta">
                  <span className="date">2022-05-26</span>
                </div>
                <div className="article-content">
                  <p>
                    通过友享平台分享您喜爱的优质产品，好友通过您的分享购买后在电商平台已有优惠的基础上双方都将获得额外的奖励~
                  </p>
                  <p className="text-muted">
                    &lt;大品牌产品，品质保证&gt; 您可以分析自己在主流电商平台上...
                  </p>
                </div>
                <Button
                  variant="success"
                  className="continue-reading"
                  href="https://www.uxiang123.com/2022/05/26/%e5%8f%8b%e4%ba%abapp-%e4%b9%b0%e7%9a%84%e8%b6%8a%e5%a4%9a%ef%bc%8c%e7%9c%81%e7%9a%84%e8%b6%8a%e5%a4%9a/"
                  target="_blank"
                  rel="noopener noreferrer"
                  as="a"
                >
                  点击阅读
                </Button>
              </article>

              {/* Article 2 */}
              <article className="content-article">
                <h2 className="article-title">
                  <a href="https://www.uxiang123.com/2022/05/17/privacypolicy-2/" target="_blank" rel="noopener noreferrer">
                    友享APP用户隐私政策
                  </a>
                </h2>
                <div className="article-meta">
                  <span className="date">2022-05-17</span>
                </div>
                <div className="article-content">
                  <p className="text-muted">
                    个人信息保护政策 最近更新日期：2022年6月1日 版本生效日期：2022年6月1日 温馨提示 友享深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持...
                  </p>
                </div>
                <Button
                  variant="success"
                  className="continue-reading"
                  href="https://www.uxiang123.com/2022/05/17/privacypolicy-2/"
                  target="_blank"
                  rel="noopener noreferrer"
                  as="a"
                >
                  点击阅读
                </Button>
              </article>

              {/* Article 3 */}
              <article className="content-article">
                <h2 className="article-title">
                  <a href="https://www.uxiang123.com/2022/05/17/useragreement/" target="_blank" rel="noopener noreferrer">
                    友享用户注册协议
                  </a>
                </h2>
                <div className="article-meta">
                  <span className="date">2022-05-17</span>
                </div>
                <div className="article-content">
                  <p className="text-muted">
                    一、协议条款的确认及接受 友享（包括网址为&nbsp;uxiangapp.com&nbsp;的网站，以及可在 iOS 系统及Android 系统中运行的名为「友享」的应...
                  </p>
                </div>
                <Button
                  variant="success"
                  className="continue-reading"
                  href="https://www.uxiang123.com/2022/05/17/useragreement/"
                  target="_blank"
                  rel="noopener noreferrer"
                  as="a"
                >
                  点击阅读
                </Button>
              </article>
            </Col>

            {/* Sidebar */}
            <Col lg={4} className="d-none d-lg-block">
              <aside className="sidebar">
                <Card className="download-card">
                  <Card.Body>
                    <h3 className="download-title">下载链接</h3>
                    <div className="download-links">
                      <a
                        href="https://apps.apple.com/cn/app/%E5%8F%8B%E4%BA%AB-%E4%B9%B0%E7%9A%84%E8%B6%8A%E5%A4%9A-%E7%9C%81%E7%9A%84%E8%B6%8A%E5%A4%9A/id1457532937"
                        className="download-btn ios-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="download-icon">
                          <i className="bi bi-apple"></i>
                        </div>
                        <div className="download-info">
                          <div className="download-label">App Store</div>
                          <div className="download-name">苹果iOS下载</div>
                        </div>
                      </a>
                      <a
                        href="https://www.uxiang123.com/wp-content/uploads/2022/05/app-release.apk"
                        className="download-btn android-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="download-icon">
                          <i className="bi bi-android2"></i>
                        </div>
                        <div className="download-info">
                          <div className="download-label">APK 直接下载</div>
                          <div className="download-name">安卓下载链接</div>
                        </div>
                      </a>
                    </div>
                  </Card.Body>
                </Card>
              </aside>
            </Col>
          </Row>
        </Container>
      </main>

      {/* Footer */}
      <footer className="site-footer">
        <Container>
          <Row className="py-4">
            <Col md={6} className="text-center text-md-start">
              <p className="mb-1">
                <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
                  沪ICP备17022729号-3
                </a>
              </p>
            </Col>
            <Col md={6} className="text-center text-md-end">
              <p className="mb-1">
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502004374" target="_blank" rel="noopener noreferrer">
                  沪公网安备 31010502004374号
                </a>
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default Home;
